import styled, { css } from 'styled-components'
import Media from 'components/common/Media'

export const Col = styled.div`
  float: left;
  width: ${props => props.width || '252px'};
  padding: ${props => props.padding || '0 12px 40px'};
  ${props => props.small && css`
    padding: 0 12px;
  `}
  ${Media.mobile`
    width: 100%;
    padding: 0 0 30px;
    ${props => props.first && css`
      padding: 0 0 20px;
    `}
    ${props => props.small && css`
      padding: 0;
      width: ${props => props.width || '100%'};
    `}
  `}
`
